export type MonthSearchesType = {
  month: string;
  postcode: number;
  fuzzy: number;
};

export enum SearchTypeENUM {
  POSTCODE = 'postcode',
  FUZZY = 'fuzzy',
}

export type PaginationDataType = {
  page: number;
  take: number;
  itemCount: number;
  pageCount: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
};

export type ClientSearchesType = {
  clientId: string;
  alias: SearchTypeENUM;
  apiKey: string;
  createdAt: Date;
  totalPostcodeCount: number;
  totalFuzzyCount: number;
  todayPostcodeCount: number;
  todayFuzzyCount: number;
};

export type GetClientsSearchesResponseType = {
  clients: ClientSearchesType[];
  pagination: PaginationDataType;
};

export type CreateClientResponseType = {
  clientId: string;
  alias: SearchTypeENUM;
  apiKey: string;
};

export type ClientType = {
  clientId: string;
  alias: string;
  apiKey: string;
  createdAt: Date | string;
  updatedAt: Date | string;
  deletedAt: Date | string;
};

export type DaySearchesType = {
  date: string;
  postcode: number;
  fuzzy: number;
};

export type AddressDataType = {
  street_address: string;
  building_number: string;
  long: string;
  lat: string;
  postcode: string;
};

export type GetAddressesResponseType = AddressDataType[];

export type ActiveTableResponseType = {
  activeTable: string;
  activeTableRowsCount: number;
  reserveTableRowsCount: number;
};

export type FileStatusType = {
  fileStatusId: string;
  uploadStatus: UploadStatusesENUM;
  processingStatus: ProcessingStatusesENUM;
  fileName: string;
  referencedTable: string;
  createdAt: string | Date | null;
  updatedAt: string | Date | null;
  deletedAt: string | Date | null;
};

export enum UploadStatusesENUM {
  PENDING = 'pending',
  SUCCESS = 'success',
  FAILED = 'failed',
}

export enum ProcessingStatusesENUM {
  PENDING = 'pending',
  SUCCESS = 'success',
  FAILED = 'failed',
}
